import type { Me } from '@schwarz/contract';

import { apiSlice } from './api-slice.js';

export const authApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    /**
     * The signed-in identity. Also the app's "am I authenticated?" probe — a 401
     * here is what triggers the redirect to sign-in, so it is queried once at the
     * shell and shared from cache by everything else.
     */
    getMe: build.query<Me, void>({
      query: () => ({ url: '/auth/me' }),
      providesTags: ['Me'],
    }),

    /**
     * Sign out. Returns the IdP's end-session URL when there is one — Schwarz's
     * IdP publishes it, so sign-out really does close the upstream session.
     */
    logout: build.mutation<{ endSessionUrl: string | null; ssoStillActive: boolean }, void>({
      query: () => ({ url: '/auth/logout', method: 'POST' }),
    }),
  }),
});

export const { useGetMeQuery, useLogoutMutation } = authApi;
